export default function About() {
  return (
    <section id="about" className="py-10 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="bg-gradient-to-br from-[#1B5E20] to-[#0D3D10] rounded-2xl md:rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
            <div className="lg:col-span-3 p-6 md:p-12 lg:p-16 space-y-6 md:space-y-8">
              <div className="inline-block">
                <span className="text-[#D4AF37] text-xs md:text-sm font-bold tracking-wider uppercase">عن الملتقى</span>
                <div className="h-1 w-12 md:w-16 bg-[#D4AF37] mt-2"></div>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
                منصة وطنية لتشخيص احتياجات الشباب
              </h2>

              <p className="text-white/85 text-base md:text-lg leading-relaxed">
                ملتقى يُقام في المدينة المنورة بتنظيم جمعية ديوان الشبابية، يهدف إلى تشخيص وتحليل احتياجات الشباب في المملكة من خلال أوراق عمل علمية وورش عمل تطبيقية وحلقات نقاش ومعرض، بمشاركة الجمعيات الشبابية والجهات ذات العلاقة، وبرعاية سمو امير منطقة المدينة المنورة، للخروج بتوصيات عملية ومبادرات قابلة للتنفيذ تدعم قرارات العاملين مع الشباب في المملكة.
              </p>

              <div className="space-y-3 md:space-y-4 pt-4">
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#D4AF37] flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-base md:text-lg"></i>
                  </div>
                  <div className="text-white/90 text-sm md:text-base">
                    <strong className="text-white">رصد وتحليل احتياجات الشباب</strong> في مجالات التعليم والتوظيف والقيم والصحة والابتكار
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#D4AF37] flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-base md:text-lg"></i>
                  </div>
                  <div className="text-white/90 text-sm md:text-base">
                    <strong className="text-white">تمكين الجمعيات الشبابية</strong> من تبادل الخبرات وأفضل الممارسات
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#D4AF37] flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-base md:text-lg"></i>
                  </div>
                  <div className="text-white/90 text-sm md:text-base">
                    <strong className="text-white">إشراك الشباب</strong> في صناعة التوصيات والقرارات
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#D4AF37] flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-base md:text-lg"></i>
                  </div>
                  <div className="text-white/90 text-sm md:text-base">
                    <strong className="text-white">إنتاج أوراق سياسات</strong> وتوصيات قابلة للتطبيق
                  </div>
                </div>
                <div className="flex items-start gap-3 md:gap-4">
                  <div className="w-7 h-7 md:w-8 md:h-8 rounded-full bg-[#D4AF37] flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-base md:text-lg"></i>
                  </div>
                  <div className="text-white/90 text-sm md:text-base">
                    <strong className="text-white">تعزيز الشراكات</strong> بين القطاع الحكومي والخاص وغير الربحي
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-2 relative min-h-[350px] lg:min-h-0">
              <div className="absolute inset-0 p-4 md:p-6">
                <div className="w-full h-full rounded-xl md:rounded-2xl overflow-hidden border-2 md:border-4 border-[#D4AF37]/30 shadow-xl">
                  <img
                    src="https://static.readdy.ai/image/d635066a0d023485209a64426ae9d593/219dc2dd056f548e4f4e135d30d5dc69.png"
                    alt="المسجد النبوي الشريف - المدينة المنورة"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}